import React from 'react';
import classnames from 'classnames';
import { observer } from 'mobx-react';

import VideoPlayer from '../../components/videoComponents/VideoPlayer';
import HomeCampaign from '../../components/GuestHomePageComponents/HomeCampaign';
import MeetOurAnchorsSection from '../../components/GuestHomePageComponents/MeetOurAnchorsSection';
import SubscribeCTAButton from '../../components/GuestHomePageComponents/SubscribeCTAButton';
import CampaignStore from '../../store/CampaignStore';

import styles from './css/GuestCarouselContent.module.css';
import { CAROUSEL_CONTENT, mainCarouselContent } from './CarouselContent';
import { Splide, SplideSlide } from '@splidejs/react-splide';


function GuestCarouselContent(props) {
  const { allActiveCampaigns, user } = props;
  const { campaignToShowOnHomePage } = CampaignStore;

  return (
    <Splide
      autoPlay={true}
      className={styles['main-carousel-home']}
      options={{
        type: 'loop',
        drag: false,
        arrows: true,
        pagination: false,
        lazyLoad: true,
        classes: {
          track: styles.track
        }
      }}
    >
      {campaignToShowOnHomePage?.name && <SplideSlide>
        <HomeCampaign
          activeCampaign={campaignToShowOnHomePage}
          allActiveCampaigns={allActiveCampaigns}
          title="NAKED NEWS"
          user={user}
        />
      </SplideSlide>}
      <SplideSlide>
        <main className={styles.guestHomeMain} id="guest-home-top">
          <div className={styles.guestSectionLeft}>
            <div>
              <h1 className={styles.headerText}>Welcome to</h1>
              <b className={classnames(styles.headerText, styles.biggerText)}>
                Naked News!
              </b>
            </div>
            <div className={styles.descriptionContainer}>
              <p className={styles.description}>{mainCarouselContent.main}</p>
            </div>
            <SubscribeCTAButton
              alignRight={true}
              hideOnMobile={true}
              topText="SUBSCRIBE TO"
              title="NAKED NEWS"
            />
          </div>
          <div className={styles.guestVideoRight} id="guest-video-right-2">
            <VideoPlayer
              key="video_1"
              guestHomePage={true}
              homePage={true}
              isProgram={true}
              user={user}
            />
          </div>
          <div className={styles.descriptionContainerMobile}>
            <p className={styles.descriptionMobile}>{mainCarouselContent.main}</p>
          </div>
          <SubscribeCTAButton alignRight={true} hideOnMobile={false} title="NAKED NEWS" />
        </main>

      </SplideSlide>
      <SplideSlide>
        <MeetOurAnchorsSection
          isNNLSection={false}
          sectionContent={CAROUSEL_CONTENT.MEET_OUR_ANCHORS}
          topText="SUBSCRIBE TO"
          title="NAKED NEWS"
          user={user}
        />
      </SplideSlide>
      <SplideSlide>
        <MeetOurAnchorsSection
          isNNLSection={true}
          sectionContent={CAROUSEL_CONTENT.FANZONE}
          topText="SUBSCRIBE TO"
          title="NAKED NEWS LIVE"
          url="/live?showPaymentPopUp=1"
          user={user}
        />
      </SplideSlide>
      <SplideSlide>
        <MeetOurAnchorsSection
          isNNLSection={false}
          sectionContent={CAROUSEL_CONTENT.BIKINI_REPORT}
          topText="SUBSCRIBE TO"
          title="NAKED NEWS"
          user={user}
        />
      </SplideSlide>
    </Splide>
  );
}

export default observer(GuestCarouselContent);
